import * as React from 'react';
import { FontWeights } from '../../enums/font-weights';
import { DisplaySizes } from '../../enums/typography-display-sizes';
import { cn } from '../../utils/cn';
import { displayVariants } from '../../variants/typography-display-variants';

function Card({ className, onClick, ...props }: React.ComponentProps<'div'>) {
  const isClickable = Boolean(onClick);

  return (
    <div
      data-slot='card'
      onClick={onClick}
      className={cn(
        'rounded-lg border bg-primary text-primary shadow-sm',
        isClickable &&
          'cursor-pointer transition-colors hover:bg-tertiary/50 active:bg-tertiary',
        className
      )}
      {...props}
    />
  );
}

function CardHeader({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      {...props}
      data-slot='card-header'
      className={cn('flex flex-col space-y-1.5 px-6 py-5', className)}
    />
  );
}

function CardTitle({ className, ...props }: React.ComponentProps<'h3'>) {
  return (
    <div
      {...props}
      data-slot='card-title'
      className={cn(
        displayVariants({
          size: DisplaySizes.XS,
          weight: FontWeights.SEMIBOLD,
        }),
        'leading-none tracking-tight',
        className
      )}
    />
  );
}

function CardDescription({ className, ...props }: React.ComponentProps<'p'>) {
  return (
    <p
      {...props}
      data-slot='card-description'
      className={cn('text-tertiary', className)}
    />
  );
}

function CardAction({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card-action'
      className={cn(
        'col-start-2 row-span-2 row-start-1 self-start justify-self-end',
        className
      )}
      {...props}
    />
  );
}

function CardContent({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      {...props}
      data-slot='card-content'
      className={cn('px-6 pb-4 pt-0', className)}
    />
  );
}

function CardFooter({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card-footer'
      className={cn('flex items-center p-6 pt-0', className)}
      {...props}
    />
  );
}

export {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
};
